import type { Option } from "../../site/FormFields";

// Choices on the "Get started" form. The API accepts exactly these values, so change both together.

export const buyingWithOptions: Option[] = [
  { value: "on-my-own", label: "On my own" },
  { value: "with-partner", label: "With my partner" },
  { value: "with-family-or-friends", label: "With family or friends" },
];

export const employmentOptions: Option[] = [
  { value: "employed", label: "Employed" },
  { value: "self-employed", label: "Self-employed" },
  { value: "unemployed", label: "Not currently employed" },
];

export const ownershipOptions: Option[] = [
  { value: "none", label: "I don’t own property" },
  { value: "own-home", label: "I own the home I live in" },
  { value: "investment", label: "I own an investment property" },
  { value: "multiple", label: "I own more than one property" },
];

export const timeframeOptions: Option[] = [
  { value: "within-3-months", label: "Within 3 months" },
  { value: "3-6-months", label: "In 3–6 months" },
  { value: "6-12-months", label: "In 6–12 months" },
  { value: "12-months-plus", label: "In more than 12 months" },
];

export const propertyTypeOptions: Option[] = [
  { value: "house", label: "House" },
  { value: "townhouse", label: "Townhouse" },
  { value: "apartment", label: "Apartment or unit" },
  { value: "other", label: "Other" },
];

export const optionLabel = (options: Option[], value: string) =>
  options.find((option) => option.value === value)?.label ?? value;
